import ManageSendStatistique from '@/views/consultations/statistique-diagnostiques/manage-send-stat'
import store_dhis2 from "@/store/mods/consultations/dhis-diagnostics"
import $ from 'jquery'
import canAccessRma from '@/router/rma-access'
import Api from '@/api/api.js'

export default {
    name: 'statistique-diagnostiques',
    components: {
        ManageSendStatistique
    },
    props: [],
    data() {
        return {
            current_date_filter: {},
            curr_month: {},          // Current month of the year
            is_loading: true,
            is_error: false,
            is_empty: false,
            statistique_dhis2: {},
            toggler: 0
            ,activeTab: 'dhis2'
            ,internalFilters: { month: new Date().toISOString().slice(0, 7), sex: 'all', age_group: 'all', kind: 'all', q: '' }
            ,internalReport: { items: [], diagnostics_count: 0, consultations_count: 0, patients_count: 0 }
            ,internalLoading: false
            ,internalError: false
            ,internalTimer: null
        }
    },

    watch: {
        canAccessRma(allowed) {
            if (!allowed) {
                this.statistique_dhis2 = {}
                this.$router.replace('/dashboard')
            }
        },
        curr_month() {
            const data = {
                month: this.curr_month.id,
            }
            this.current_date_filter = data
            this.getStatDHIS2()
        },
    },

    computed: {
        canAccessRma() {
            return canAccessRma(this.$store.getters['activeRole'])
        }
    },

    mounted() {
        this.curr_month = this.monthOfYear[this.current_date.getMonth()+1]
    },
    beforeDestroy() { if (this.internalTimer) clearTimeout(this.internalTimer) },

    methods: {
        openInternalReport() {
            this.activeTab = 'internal'
            this.getInternalReport()
        },
        debouncedInternalReport() {
            if (this.internalTimer) clearTimeout(this.internalTimer)
            this.internalTimer = setTimeout(() => this.getInternalReport(), 300)
        },
        getInternalReport() {
            if (!this.canAccessRma) return
            this.internalLoading = true
            this.internalError = false
            return Api().get('/rma/internal-diagnostics', { params: this.internalFilters }).then(response => {
                this.internalReport = response.data
                this.internalLoading = false
            }).catch(() => {
                this.internalError = true
                this.internalLoading = false
            })
        },
        getStatDHIS2() {
            if (!this.canAccessRma) return
            this.is_loading = true
            this.is_error = false
            return store_dhis2.getStatConsultationDHIS2(this.current_date_filter).then((response) => {
                if (!this.canAccessRma) return
                if (!response || !response.cas_diagnostics || !response.patient_consultes || !response.maladies_parasitaires || !response.cas_paludisme ||
                    !Array.isArray(response.patient_consultes.stat) || !Array.isArray(response.maladies_parasitaires.stat)) throw new Error('Rapport incomplet')
                this.statistique_dhis2 = response

                this.is_loading = false
            }).catch(() => {
                this.is_error = true
                this.is_loading = false
                this.errorToast('Impossible de charger le RMA. Veuillez réessayer.')
            })
        },
        
        setStatToSend() {
            this.toggler = (this.toggler == 0)?1:0
            $('.stat-dhis').modal('show')
        }
    }
}


